import authRequest from '../authRequest';
import { getCurrentUser, setCurrentUser } from '../userStorage';

const updateUserProfile = async (profileAttributes) => {
  try {
    const response = await authRequest('/user_profile', {
      method: 'PATCH',
      data: { user_profile: profileAttributes },
    });

    if (response.status === 200 && response.data) {
      const currentUser = getCurrentUser();
      
      setCurrentUser({
        ...currentUser,
        profile: response.data
      });

      return response.data;
    } else {
      throw new Error('Failed to update user profile: Invalid response');
    }
  } catch (error) {
    console.error('Error updating user profile:', error);
    throw error;
  }
};

export default updateUserProfile;